const getDefaultState = () => {
  return {
    visitedViews: [],
    cachedViews: []
  }
}

const tagsView = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    ADD_VISITED_VIEW: (state, view) => {
      let title = (view.params && view.params.recordLabel) ? view.meta.title + ':' + view.params.recordLabel : view.meta.title
      if (state.visitedViews.some(v => {
        if (view.params && view.params.recordLabel && view.params.recordLabel === v.params.recordLabel && v.path === view.path) return true
        return view.params.recordLabel === undefined && v.path === view.path
      })) {
        return
      }
      state.visitedViews.push(
        Object.assign({}, view, {title: title || 'no-name'})
      )
    },
    ADD_CACHED_VIEW: (state, view) => {
      let title = (view.params && view.params.recordId) ? view.meta.title + ':' + view.params.recordId : view.meta.title
      if (state.cachedViews.includes(title)){
        return
      }

      if (!view.meta.noCache) {
        state.cachedViews.push(title)
      }
    },

    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path && view.params && view.params.recordId === v.params.recordId) {
          state.visitedViews.splice(i, 1)
          break;
        }
        else if (view.params.recordId === undefined && v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
    },
    DEL_CACHED_VIEW: (state, view) => {
      for (const i of state.cachedViews) {
        let title = (view.params && view.params.recordId) ? view.meta.title + ':' + view.params.recordId : view.meta.title
        if (i === title) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },

    DEL_OTHERS_VISITED_VIEWS: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path && view.params && view.params.recordId === v.params.recordId) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break;
        }
        else if (view.params.recordId === undefined && v.path === view.path) {
          state.visitedViews = state.visitedViews.slice(i, i + 1)
          break
        }
      }
    },
    DEL_OTHERS_CACHED_VIEWS: (state, view) => {
      for (const i of state.cachedViews) {
        let title = (view.params && view.params.recordId) ? view.meta.title + ':' + view.params.recordId : view.meta.title
        if (i === title) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, index + 1)
          break
        }
      }
    },

    DEL_ALL_VISITED_VIEWS: state => {
      state.visitedViews = []
    },
    DEL_ALL_CACHED_VIEWS: state => {
      state.cachedViews = []
    },

    UPDATE_VISITED_VIEW: (state, view) => {
      for (let v of state.visitedViews) {
       if (v.path === view.path) {
        let title = (view.params && view.params.recordLabel) ? view.meta.title + ':' + view.params.recordLabel : view.meta.title
         if (v.params && view.params && view.params.recordId === v.params.recordId) {
          v.title = title
          v = Object.assign(v, view)
            break
         }
       }
      }
    },
    RESET_STORE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    addView({ dispatch }, view) {
      dispatch('addVisitedView', view)
      dispatch('addCachedView', view)
    },
    addVisitedView({ commit }, view) {
      commit('ADD_VISITED_VIEW', view)
    },
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },

    delView({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delVisitedView', view)
        dispatch('delCachedView', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delVisitedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
    delCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },

    delOthersViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delOthersVisitedViews', view)
        dispatch('delOthersCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delOthersVisitedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_VISITED_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersCachedViews({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_OTHERS_CACHED_VIEWS', view)
        resolve([...state.cachedViews])
      })
    },

    delAllViews({ dispatch, state }, view) {
      return new Promise(resolve => {
        dispatch('delAllVisitedViews', view)
        dispatch('delAllCachedViews', view)
        resolve({
          visitedViews: [...state.visitedViews],
          cachedViews: [...state.cachedViews]
        })
      })
    },
    delAllVisitedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_VISITED_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    delAllCachedViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DEL_ALL_CACHED_VIEWS')
        resolve([...state.cachedViews])
      })
    },

    updateVisitedView({ commit }, view) {
      commit('UPDATE_VISITED_VIEW', view)
    }
  }
}

export default tagsView
